module.exports = __webpack_public_path__ + "img/seokmi.39c7434b.svg";